import type { EnemyKind } from './enemies'

export type DisruptionId = 'SIGNAL_JAM' | 'RANGE_SCRAMBLE'

export interface DisruptionDefinition {
  readonly id: DisruptionId
  readonly name: string
  readonly glyph: string
  readonly description: string
  readonly sourceKind: EnemyKind
  readonly radius: number
  readonly attackSpeed: number
  readonly range: number
  readonly color: number
  readonly cssColor: string
}

export const DISRUPTIONS: Record<DisruptionId, DisruptionDefinition> = {
  SIGNAL_JAM: {
    id: 'SIGNAL_JAM', name: 'SIGNAL JAM', glyph: '⌁', sourceKind: 'FUD_BOT', radius: 175,
    description: 'FUD BOT interference reduces nearby tower attack speed by 24%.',
    attackSpeed: 0.76, range: 1, color: 0xff4f79, cssColor: '#ff4f79',
  },
  RANGE_SCRAMBLE: {
    id: 'RANGE_SCRAMBLE', name: 'RANGE SCRAMBLE', glyph: '⌖', sourceKind: 'LIQUIDATOR', radius: 145,
    description: 'Liquidator distortion reduces nearby tower targeting range by 18%.',
    attackSpeed: 1, range: 0.82, color: 0x9a78ff, cssColor: '#9a78ff',
  },
}

export const DISRUPTION_IDS = Object.keys(DISRUPTIONS) as DisruptionId[]

export const COUNTERMEASURES = {
  ETH_PURGE: { name: 'CONSENSUS PURGE', description: 'Level II ETH towers cleanse all disruption within 230 range; Beacon Matrix extends this to 310.' },
  SOL_FILTER: { name: 'PACKET FILTER', description: 'Level II SOL towers resist 50% of Signal Jam attack-speed loss.' },
  BTC_UPLINK: { name: 'HARDENED UPLINK', description: 'Level II BTC towers resist 50% of Range Scramble loss.' },
} as const
